import { useState, useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { useSnackBar } from '@/context/app-context'
import styles from './select.module.scss'

export default function MultiSelect(props) {
  const snackbar = useSnackBar()
  const {
    label,
    placeholder = 'Placeholder',
    items = [],
    stylingClass = '',
    disabled = false,
    onSelect = () => {},
    value = [],
    itemTextKey,
    itemValueKey,
    errorText = '',
    maxSelectItem,
    ...otherProps
  } = props
  const textKey = itemTextKey || 'text'
  const valueKey = itemValueKey || 'value'
  const [isActive, setIsActive] = useState(false)
  const [selectedValues, setSelectedValues] = useState([])
  const selectRef = useRef()
  const handleClickOutside = (e) => {
    if (selectRef.current && !selectRef.current.contains(e.target)) {
      setIsActive(false)
    }
  }

  const checkIsSelected = (item) => selectedValues.find((val) => val[valueKey] === item[valueKey])

  const selectItem = (e) => (isSelected, selectedItem) => {
    if (maxSelectItem) {
      if (selectedValues.length >= maxSelectItem && !isSelected) {
        snackbar({
          content: `Maximum select category is ${maxSelectItem}`
        })
        return false
      }
    }
    e.stopPropagation()
    let valueToUpdate = []
    if (isSelected) {
      valueToUpdate = selectedValues.filter((item) => item[valueKey] !== selectedItem[valueKey])
    } else {
      valueToUpdate = [...selectedValues, selectedItem]
    }
    onSelect(valueToUpdate)
    setSelectedValues(valueToUpdate)
    return true
  }

  useEffect(() => {
    if (items.length > 0 && value) {
      if (Array.isArray(value) && value.length) {
        const matchedItem = []
        const ids = value.map((item) => {
          return item?.[valueKey] || item
        })
        ids.forEach((id) => {
          const foundItem = items.find((item) => item[valueKey] === id)
          if (foundItem) {
            matchedItem.push(foundItem)
          }
        })
        setSelectedValues(matchedItem)
      } else if (typeof value === 'string') {
        const foundItem = items.find((item) => item[valueKey] === value)
        setSelectedValues([foundItem])
      }
    }
  }, [value, valueKey, items])

  useEffect(() => {
    if (isActive) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isActive])

  return (
    <div
      ref={selectRef}
      className={`${styles.selectWrapper} ${stylingClass} ${errorText && styles.invalid}`}
      onClick={() => setIsActive(!isActive)}
      invalid={errorText && 'true'}
      disabled={disabled}
      {...otherProps}
    >
      {label && <span className={styles.label}>{label}</span>}
      <div className={`${styles.select} ${isActive && styles.active}`}>
        {
          selectedValues.length
            ? <span className={`${styles.text}`}>{selectedValues.map((item) => item[textKey]).join(', ')}</span>
            : <span className={`${styles.text} ${styles.placeholder}`}>{placeholder}</span>
        }
        <span className={styles.icon}>
          <FontAwesomeIcon icon={faChevronDown} width={20} />
        </span>
        <input type="hidden" value={selectedValues?.[valueKey] || ''} />
        {
          !!items.length && (
            <ul className={styles.itemList}>
              {items.map((item, index) => (
                <li
                  className={
                  `${styles.item} ${checkIsSelected(item) && styles.active}`
                }
                  key={index}
                  onClick={(e) => selectItem(e)(checkIsSelected(item), item)}
                >
                  <div className={styles.itemText}>{item[textKey] || ''}</div>
                  {
                    checkIsSelected(item)
                    && (
                    <span className={styles.itemIconActive}>
                      <FontAwesomeIcon icon={faCheck} />
                    </span>
                    )
                  }
                </li>
              ))}
            </ul>
          )
        }
      </div>
      {errorText && <span className={styles.error}>{errorText}</span>}
    </div>
  )
}

// example
// <Select
//   label="Label"
//   stylingClass={styles.input}
//   items={[
//     {
//       text: 'test 1',
//       value: 'val1'
//     },
//     {
//       text: 'test 2 test 2test 2test 2',
//       value: 'val2'
//     },
//     {
//       text: 'test 3',
//       value: 'val3'
//     },
//   ]}
// />
// example
